import React, { useState, useEffect } from 'react';
import api from '../../api/api';
import AdminLayout from '../../components/AdminLayuot';

const THEME = {
    primary: '#1F2937',
    secondary: '#3B82F6',
    success: '#10B981',
    danger: '#EF4444',
    bg: '#F3F4F6',
    white: '#FFFFFF',
    border: '#E5E7EB'
};

const PRODUCTOS = [
    { key: 'CAFE_AMERICANO', label: 'Café Americano', color: '#78350F' },
    { key: 'ESPECIALIDAD_CHIAPAS', label: 'Especialidad Chiapas', color: '#065F46' },
    { key: 'ESPECIALIDAD_GUERRERO', label: 'Especialidad Guerrero', color: '#9F1239' },
    { key: 'DESCAFEINADO', label: 'Descafeinado', color: '#92400E' },
    { key: 'CAFE_DE_OLLA', label: 'Café de Olla', color: '#D97706' },
    { key: 'CAFE_EJECUTIVO', label: 'Mezcla Ejecutiva', color: '#1E3A8A' }
];

function AdminAlmacen() {
    const [bodega, setBodega] = useState(null);
    const [inventario, setInventario] = useState({});
    const [loading, setLoading] = useState(true);
    
    // Modal
    const [showModal, setShowModal] = useState(false);
    // Agregamos 'presentacion' (GRANO o MOLIDO)
    const [prodForm, setProdForm] = useState({ producto: '', cantidad: '', tipo: 'ENTRADA', presentacion: 'GRANO' }); 
    const [saving, setSaving] = useState(false);

    const fetchMiBodega = async () => {
        const token = localStorage.getItem('token');
        try {
            const { data } = await api.get('/sucursales/me', { headers: { Authorization: `Bearer ${token}` } });
            if (data.length > 0) {
                const miSucursal = data[0];
                setBodega(miSucursal);
                
                const mapa = {};
                if(miSucursal.inventarios) {
                    miSucursal.inventarios.forEach(item => {
                        // Guardamos un objeto con AMBOS valores
                        mapa[item.producto] = {
                            grano: Number(item.cantidadGrano || 0),
                            molido: Number(item.cantidadMolido || 0)
                        };
                    });
                }
                setInventario(mapa);
            }
        } catch (error) { console.error(error); } finally { setLoading(false); }
    };

    useEffect(() => { fetchMiBodega(); }, []);

    const openModal = (productoKey, tipo) => {
        setProdForm({
            producto: productoKey,
            cantidad: '',
            tipo: tipo, // ENTRADA o SALIDA
            presentacion: 'GRANO' // Por defecto
        });
        setShowModal(true);
    };

    const handleGuardar = async (e) => {
        e.preventDefault();
        setSaving(true);
        const token = localStorage.getItem('token');
        
        try {
            let cantidadFinal = Number(prodForm.cantidad);
            if (prodForm.tipo === 'SALIDA') cantidadFinal *= -1;

            await api.post('/sucursales/stock/add', {
                sucursalId: bodega.id,
                producto: prodForm.producto,
                cantidad: cantidadFinal,
                tipo: prodForm.presentacion // 'GRANO' o 'MOLIDO'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            alert("✅ Inventario actualizado");
            setShowModal(false);
            fetchMiBodega();

        } catch (error) { alert("Error al guardar"); } finally { setSaving(false); }
    };

    const cardStyle = { background: THEME.white, padding: 20, borderRadius: 12, boxShadow: '0 4px 6px rgba(0,0,0,0.05)', display: 'flex', flexDirection: 'column', borderTop: '5px solid transparent' };
    const btnActionStyle = (color) => ({
        flex: 1, padding: '6px 0', border: 'none', borderRadius: 6, cursor: 'pointer',
        fontWeight: 'bold', color: 'white', background: color, fontSize: 13
    });

    if (loading) return <AdminLayout title="Mi Almacén"><div style={{textAlign:'center', marginTop:50}}>Cargando...</div></AdminLayout>;
    if (!bodega) return <AdminLayout>No tienes bodega.</AdminLayout>;

    return (
        <AdminLayout title={`🏭 ${bodega.nombre}`}>
             <div style={{ marginBottom: 30 }}>
                <h2 style={{ margin: 0, color: THEME.primary }}>Inventario Detallado</h2>
                <p style={{ margin: 0, color: '#6B7280' }}>Control de Grano y Molido.</p>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 20 }}>
                {PRODUCTOS.map(prod => {
                    const stock = inventario[prod.key] || { grano: 0, molido: 0 };
                    const total = stock.grano + stock.molido;
                    
                    return (
                        <div key={prod.key} style={{ ...cardStyle, borderTopColor: prod.color }}>
                            
                            {/* CABECERA */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 15 }}>
                                <div style={{ fontSize: 13, fontWeight: 'bold', color: '#9CA3AF' }}>{prod.label}</div>
                                <div style={{ fontSize: 16, fontWeight: 'bold', color: THEME.primary }}>Total: {total.toFixed(1)} Kg</div>
                            </div>

                            {/* DETALLE DIVIDIDO */}
                            <div style={{ display: 'flex', gap: 10, marginBottom: 20 }}>
                                <div style={{ flex: 1, background: '#F3F4F6', padding: 10, borderRadius: 8, textAlign: 'center' }}>
                                    <div style={{ fontSize: 12, color: '#6B7280' }}>🫘 GRANO</div>
                                    <div style={{ fontSize: 20, fontWeight: 'bold', color: '#1F2937' }}>{stock.grano.toFixed(1)}</div>
                                </div>
                                <div style={{ flex: 1, background: '#EFF6FF', padding: 10, borderRadius: 8, textAlign: 'center' }}>
                                    <div style={{ fontSize: 12, color: '#6B7280' }}>⏳ MOLIDO</div>
                                    <div style={{ fontSize: 20, fontWeight: 'bold', color: '#1F2937' }}>{stock.molido.toFixed(1)}</div>
                                </div>
                            </div>

                            {/* BOTONES */}
                            <div style={{ display: 'flex', gap: 10 }}>
                                <button onClick={() => openModal(prod.key, 'SALIDA')} style={btnActionStyle(THEME.danger)}>➖ Salida</button>
                                <button onClick={() => openModal(prod.key, 'ENTRADA')} style={btnActionStyle(THEME.success)}>➕ Entrada</button>
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* MODAL */}
            {showModal && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
                    <div style={{ background: 'white', padding: 30, borderRadius: 16, width: 350 }}>
                        <h3 style={{ marginTop: 0, color: prodForm.tipo === 'ENTRADA' ? THEME.success : THEME.danger }}>
                            {prodForm.tipo === 'ENTRADA' ? '📥 Registrar Entrada' : '📤 Registrar Salida'}
                        </h3>
                        <p style={{fontSize:13, color:'#6B7280'}}>{PRODUCTOS.find(p=>p.key===prodForm.producto)?.label}</p>
                        
                        <form onSubmit={handleGuardar}>
                            {/* SELECTOR DE PRESENTACIÓN */}
                            <div style={{ display: 'flex', gap: 10, marginBottom: 20 }}>
                                <button 
                                    type="button"
                                    onClick={() => setProdForm({...prodForm, presentacion: 'GRANO'})}
                                    style={{ flex: 1, padding: 10, border: prodForm.presentacion === 'GRANO' ? `2px solid ${THEME.primary}` : '1px solid #E5E7EB', borderRadius: 8, background: prodForm.presentacion === 'GRANO' ? '#F3F4F6' : 'white', cursor:'pointer' }}
                                >
                                    🫘 Grano
                                </button>
                                <button 
                                    type="button"
                                    onClick={() => setProdForm({...prodForm, presentacion: 'MOLIDO'})}
                                    style={{ flex: 1, padding: 10, border: prodForm.presentacion === 'MOLIDO' ? `2px solid ${THEME.secondary}` : '1px solid #E5E7EB', borderRadius: 8, background: prodForm.presentacion === 'MOLIDO' ? '#EFF6FF' : 'white', cursor:'pointer' }}
                                >
                                    ⏳ Molido
                                </button>
                            </div>

                            <label style={{display:'block', fontWeight:'bold', marginBottom: 5}}>Cantidad (Kg)</label>
                            <input 
                                type="number" step="0.1" autoFocus required 
                                style={{ width: '100%', padding: 12, borderRadius: 8, border: '1px solid #ccc', fontSize: 18, marginBottom: 20 }}
                                value={prodForm.cantidad} onChange={e => setProdForm({...prodForm, cantidad: e.target.value})}
                            />
                            
                            <div style={{ display: 'flex', gap: 10 }}>
                                <button type="button" onClick={() => setShowModal(false)} style={{ flex: 1, padding: 10, background: '#eee', border: 'none', borderRadius: 6, cursor: 'pointer' }}>Cancelar</button>
                                <button type="submit" disabled={saving} style={{ flex: 1, padding: 10, background: prodForm.tipo==='ENTRADA'?THEME.success:THEME.danger, color: 'white', border: 'none', borderRadius: 6, fontWeight:'bold', cursor: 'pointer' }}>Confirmar</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </AdminLayout>
    );
}

export default AdminAlmacen;